import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { makeCityNameValidators } from './cityName';
import { makeCompanyNameValidators } from './companyName';
import { makeEmailValidators } from './email';
import { makeInvoicePrefixValidators } from './invoicePrefix';
import { makeMaxLengthValidation } from './maxLength';
import { makeNameValidators } from './name';
import { makeNoHtmlPatternValidation } from './noHtmlPattern';
import { makePhoneNumberValidators } from './phoneNumber';
import { makePostalCodeValidators } from './postalCode';
import { makeRichTextValidators } from './richText';
import { makeStreetNameValidators } from './streetName';
import { makeTitleValidators } from './title';
export const createValidators = (messages)=>_object_spread_props(_object_spread({}, makeNameValidators(messages), makeTitleValidators(messages), makeEmailValidators(messages), makeCompanyNameValidators(messages), makeRichTextValidators(messages), makeStreetNameValidators(messages), makeCityNameValidators(messages), makePostalCodeValidators(messages), makePhoneNumberValidators(messages), makeInvoicePrefixValidators(messages)), {
        maxLengthValidation: makeMaxLengthValidation(messages),
        noHtmlPatternValidation: makeNoHtmlPatternValidation(messages)
    });
